import { createApp } from 'vue'
import Antd from 'ant-design-vue'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import 'ant-design-vue/dist/reset.css'
import './styles/global/_global.scss'
import router from './router'
import './router/router-guard'
import plugins from './plugins'
import filters from './filters'
import App from './App.vue'

import clickOutside from '@/directives/clickOutside.ts'
import SafeHtml from '@/directives/safeHtml.ts'
import { decrypt, encrypt } from '@/utils/crypto.ts'

const pinia = createPinia()
pinia.use(
  createPersistedState({
    serializer: {
      serialize: (state: any) => {
        try {
          const json = JSON.stringify(state)
          return import.meta.env.PROD ? encrypt(json) : json
        } catch (error) {
          console.error('Serialization error:', error)
          return state
        }
      },
      deserialize: (value: string) => {
        try {
          const decrypted = import.meta.env.PROD ? decrypt(value) : value
          return JSON.parse(decrypted)
        } catch (error) {
          console.error('Deserialization error:', error)
          return value
        }
      },
    },
  })
)
const app = createApp(App)

app
  .use(pinia)
  .use(Antd)
  .use(router)
  .use(plugins)
  .directive('click-outside', clickOutside)
  .directive('safe-html', SafeHtml)
  .mount('#app')
app.config.globalProperties.$filters = filters
